




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import OSS from "ali-oss";
import ossConfig from "@/lib/ossConfig";
import hwyConfig from "@/lib/hwyConfig";
declare var ObsClient: any;
var SEVER = "OBS"; // OSS | OBS
@Component
export default class UploadOSS extends Vue {
  // 接受的上传类型
  @Prop({ type: String, default: "image/*" })
  accept: string;
  // 是否可以多张上传
  @Prop({ type: Boolean, default: true })
  multiple: boolean;
  // 接受的上传的数量 -1表示不限制
  @Prop({ type: Number, default: 20 })
  uploadNum: number;
  @Prop({ type: String, default: "上传图片" })
  buttonText: string;
  @Prop({ type: String, default: "oss-upload" })
  refName: string;
  // 存储oss/obs的文件夹
  @Prop({ type: String, default: "" })
  dir: string;
  @Prop({ type: String, default: "" })
  randomtype: string;
  // 是否显示图片样式
  @Prop({ type: Boolean, default: false })
  isShowImg: boolean;

  isUpload = false; // 是否正在上传
  /**
   * 选择文件
   */
  chooseFn() {
    if (this.isUpload) {
      return;
    }
    let upload: any = this.$refs[this.refName];
    upload.click();
  }

  /**
   * 选择文件
   */
  getFile(event) {
    let len = event.target.files.length;

    if (len > this.uploadNum && this.uploadNum != -1) {
      len = this.uploadNum;
    }
    let fileList = [];
    for (let i = 0; i < len; i++) {
      let file = event.target.files[i];
      fileList.push(file);
    }

    this.beforeUpload(fileList);

    let upload: any = this.$refs[this.refName];
    upload.value = ""; // 清空file文件
  }

  /**
   * 上传前判断
   */
  beforeUpload(fileList) {
    var vm = this;
    if (fileList.length == 0) {
      vm.$Message.warning("请选择文件！");
      return false;
    }
    vm.$Message.config({
      top: 260,
    });
    vm.$Message.loading({
      content: "上传中…",
      duration: 0,
    });
    vm.isUpload = true;
    let list = [];
    fileList.forEach((file) => {
      if (file.type.indexOf("image") > -1) {
        vm.compress(file).then((from) => {
          vm.uploadFn(from)
            .then((res: any) => {
              console.log(res);
              list.push(res);
              if (list.length == fileList.length) {
                vm.uploadFinish();
                vm.$emit("uploadChange", list);
              }
            })
            .catch((err) => {
              vm.uploadFinish(true);
            });
        });
      } else {
        vm.uploadFn(file)
          .then((res: any) => {
            console.log(res);
            list.push(res);
            if (list.length == fileList.length) {
              vm.uploadFinish();
              vm.$emit("uploadChange", list);
            }
          })
          .catch((err) => {
            vm.uploadFinish(true);
          });
      }
    });
  }

  /** 上传文件 */
  uploadFn(file) {
    let vm = this;
    return new Promise((resolve, reject) => {
      if (file == undefined) {
        return false;
      }
      // let randomName = `${vm.dir}_${new Date().getTime()}${file.name}`
      let dir = 'image/'
      let randomName = `${new Date().getTime()}${file.name}`;
      if (vm.randomtype == "mainPicture") {
        dir = vm.dir
        randomName = file.name;
      }
      // console.log('文件名', `${vm.dir}_${new Date().getTime()}${file.name}`, file)
      if (SEVER == "OBS") {
        const hwyClient = new ObsClient(hwyConfig.hwyParams);
        // console.log('函数', hwyClient)
        hwyClient
          .putObject({
            Bucket: "pinwei",
            // Body: randomName,
            Key: `${dir}${randomName}`,
            SourceFile: file,
            ContentType: "image/png",
          })
          .then((res) => {
            console.log("成功", res);
            resolve({
              url: `https://pinwei.obs.cn-south-1.myhuaweicloud.com/image/${randomName}`,
              fileName: randomName,
            });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      } else {
        var client = new OSS(ossConfig.ossParams);
        client
          .put(`${dir}${randomName}`, file)
          .then((result) => {
            console.log(result);
            // 成功之后的操作
            resolve({
              url: result.url,
              fileName: randomName,
            });
          })
          .catch((err) => {
            reject(err);
          });
      }
    });
  }

  /**
   * 图片压缩
   */
  compress(file) {
    //file是指上传的图片，obj是压缩的品质，越低越模糊
    let vm: any = this;
    return new Promise(function(resolve, reject) {
      //大于5M压缩
      if (file.size / 1024 > 5 * 1024) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          const image: any = new Image(); // 新建一个img标签（还没嵌入DOM节点)
          image.src = (<FileReader>e.target).result;
          image.onload = () => {
            const canvas = document.createElement("canvas"),
              context = canvas.getContext("2d");
            //设置压缩图片的最大高度
            var MAX_HEIGHT = 960;
            // 如果高度超标
            if (image.height > MAX_HEIGHT && image.height >= image.width) {
              // 宽度等比例缩放 *=
              image.width *= MAX_HEIGHT / image.height;
              image.height = MAX_HEIGHT;
            }
            //考录到用户上传的有可能是横屏图片同样过滤下宽度的图片。
            if (image.width > MAX_HEIGHT && image.width > image.height) {
              // 宽度等比例缩放 *=
              image.height *= MAX_HEIGHT / image.width;
              image.width = MAX_HEIGHT;
            }
            let data = "";
            let imageWidth = image.width; // 压缩后图片的大小
            let imageHeight = image.height;
            canvas.width = imageWidth;
            canvas.height = imageHeight;

            context.drawImage(image, 0, 0, imageWidth, imageHeight);
            data = canvas.toDataURL("image/jpeg");
            let bl = vm.convertBase64UrlToBlob(data);
            bl["name"] = file.name;
            resolve(bl);
          };
        };
      } else {
        resolve(file);
      }
    });
  }

  //将base64码转化为file（Blob）
  //此处函数对压缩后的base64经过处理返回{size: "", type: ""}
  convertBase64UrlToBlob(urlData) {
    var arr = urlData.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  /**
   * 上传完成处理
   */
  uploadFinish(err = false) {
    let vm = this;
    vm.isUpload = false;
    vm.$Message.destroy();
    if (err) {
      vm.$Notice.error({ title: "上传失败" });
    }
  }
}
